const actions = {
  SET_STATE: 'configs/SET_STATE',
  GET_DATA: 'configs/GET_DATA',
}

export default actions
